import { render, staticRenderFns } from "./MortalityDistributionHorizontalBarGraph.vue?vue&type=template&id=5522a778&"
import script from "./MortalityDistributionHorizontalBarGraph.vue?vue&type=script&lang=js&"
export * from "./MortalityDistributionHorizontalBarGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports